import React from 'react';

function RoundLabel({
    number,
}) {
    return (
        <div className="min-w-[32px] min-h-[32px] rounded-full bg-cleanSlate flex justify-center items-center text-cirrusWhite font-instrument text-base font-medium leading-125">
            {number}
        </div>
    );
}

export default RoundLabel;
